import React from 'react'
import './Footer.css'
import { useTranslation } from "react-i18next";
const Footer = () => {
  const [t] = useTranslation();
  return (
    <div style={{backgroundColor:"#5be3e3"}}>
  <footer id="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <a href="index.html"><img src="/images/logo.png" alt="" className="img-fluid logo-footer"/></a>
                      

          </div>
          <div className="col-md-3">
            <div className="useful-link">
              <h2>{t('footer9')}</h2>
              <img src="./assets/images/about/home_line.png" alt="" className="img-fluid"/>
              <div className="use-links">
                <li><a href="#home"><i className="fa-solid fa-angles-right"></i> {t('footer0')}</a></li>
                <li><a href="#About"><i className="fa-solid fa-angles-right"></i>{t('footer1')}</a></li>
                <li><a href="#Roadmap"><i className="fa-solid fa-angles-right"></i> {t('footer2')}</a></li>
                <li><a href="#contact"><i className="fa-solid fa-angles-right"></i> {t('footer3')}</a></li>
              </div>
            </div>

          </div>
                    <div className="col-md-3">
                        <div className="social-links">
              <h2>{t('footer7')}</h2>
              <img src="./assets/images/about/home_line.png" alt=""/>
              <div className="social-icons">
                <li><a href="https://t.me/wte_global_channel"><i className="fa-brands fa-telegram"></i> Telegram</a></li>
                <li><a href="https://twitter.com/wtenergytech"><i className="fa-brands fa-twitter"></i> Twitter</a></li>
                
              </div>
            </div>
                    

                    </div>
          <div className="col-md-3">
            <div className="address">
              <h2>{t('footer8')}</h2>
              <img src="./assets/images/about/home_line.png" alt="" className="img-fluid"/>
              <div className="address-links">
                <li className="address1"><i className="fa-solid fa-location-dot"></i> Office No. 43-44

                  Owned by Dubai Municipality

                  Bur Dubai- Al Fahidi</li>
                   
                   <li><a href="non"><i className="fa-solid fa-envelope"></i> admin@wtenergy.tech</a></li>
              </div>
            </div>
          </div>
                  
        </div>
      </div>

    </footer>
</div>
  )
}

export default Footer
